import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { preLoadImage } from "../service/preLoadImage";
import { nextPageRoute } from "../utils/modules";
import ImageLoader from "./ImageLoader";

const HorizontalButton = ({
  navigateTo,
  image,
  label,
  className,
  imagesToPreload,
  placeHolderImage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = () => {
    nextPageRoute(navigate, navigateTo, dispatch, imagesToPreload);
  };

  return (
    <button
      tabIndex="0"
      onClick={handleNavigate}
      className="my-2 btn container-fluid rounded-2 d-flex justify-content-between align-items-center px-3  object-fit-contain link-underline link-underline-opacity-0 button-highlight"
      style={{
        backgroundColor: "#F2F2F2",
      }}
    >
      <p
        className={`m-0 fw-bold ${className}`}
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      >
        {label}
      </p>
      {image && (
        <div
          className="d-flex justify-content-center  align-content-center "
          style={{ height: "40px", width: "60px" }}
        >
          <ImageLoader
            placeHolderImage={placeHolderImage}
            src={image}
            alt="emoji"
            className="imgClass"
            style={{
              maxHeight: "40px",
              maxWidth: "60px",
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </button>
  );
};

export default HorizontalButton;
